module.exports = __webpack_public_path__ + "img/courier-forwardair.d2410f00.svg";